import React from 'react';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { INCREASE_SCORE_TIPS } from 'types/morph.pagePosition.constants';
import IncreaseScoreTipsView from './IncreaseScoreTipsView';
import { useIncreaseScoreTips } from './hooks/IncreaseScoreTips.hook';
import { useUserInfo } from 'hook/data/userInfo.hook';

const IncreaseScoreTipsController = props => {
  const { modulePosition } = props;
  const { onLinkClick } = useIncreaseScoreTips(props, INCREASE_SCORE_TIPS);
  const { userInfo } = useUserInfo();

  const atr = getViewModuleTrackingAttributes({
    pagePosition: INCREASE_SCORE_TIPS,
    modulePosition: modulePosition,
    vertical: 'Auto Loan',
  });

  useViewModule(atr);
  const seenPixel = useSeenModulePixel(atr);

  return (
    <IncreaseScoreTipsView
      seenPixel={seenPixel}
      onLinkClick={onLinkClick}
      userInfo={userInfo}
    />
  );
};

export default IncreaseScoreTipsController;
